<template>
  <v-dialog :value="dialog" fullscreen persistent @input="$emit('close')">
    <v-card>
      <v-toolbar color="primary" dark dense flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon :href="pdf" :download="filename" :disabled="!pdf" title="Baixar PDF">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0 modal-pdf__body">
        <iframe v-if="pdf" :src="pdf" class="modal-pdf__frame" frameborder="0" />
        <div v-else class="modal-pdf__empty">
          <v-icon large color="grey lighten-1">mdi-file-pdf-box</v-icon>
          <div class="mt-2 text--disabled">Nenhum PDF disponível</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EModalEspelhoPontoPdf",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    pdf: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Espelho de Ponto",
    },
    filename: {
      type: String,
      default: "espelho-ponto.pdf",
    },
  },
};
</script>

<style scoped>
.modal-pdf__body {
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}
.modal-pdf__frame {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}
.modal-pdf__empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
